var provider = {
	phone_format: '(###) ### ## ##',

	prefix: ['mr.', 'mevr.', 'dr.'],

	company_suffixes: ['BV', 'NV', 'Groep', 'en Zonen'],

	// Three random Dutch names (male and female)
	first_names: [
		'Abke', 'Anne', 'Anouk',
		'Baukje', 'Birgit', 'Bo',
		'Carlijn', 'Casper', 'Claudia',
		'Danny', 'Debbie', 'Dominique',
		'Elise', 'Ed', 'Elwin',
		'Flip', 'Frank', 'Freek',
		'Geert', 'Georgina', 'Gwenda',
		'Hendrik', 'Hedwig', 'Hilke',
		'Inge', 'Isaak', 'Ivo',
		'Jaap', 'Jack', 'Jasmijn',
		'Kristen', 'Klaartje', 'Klaas',
		'Lander', 'Lars', 'Leonie',
		'Maaike', 'Marjan', 'Maarten',
		'Nico', 'Nynke', 'Noortje',
		'Olivia', 'Oscar', 'Olivier',
		'Peter', 'Pim', 'Petra',
		'Qwen', 'Quin', 'Quintus',
		'Raplh', 'Rudolf', 'Rachel',
		'Silvia', 'Sandra', 'Sander',
		'Tomas', 'Tim', 'Tess',
		'Ulke', 'Urbanus', 'Uri',
		'Victor', 'Vanessa', 'Veerle',
		'Willeke', 'Willem', 'Wander',
		'Xander', 'Xavier',
		'Yvon', 'Yannick', 'Yvo',
		'Zander', 'Zara', 'Zoë'
	],

	last_names: [
		'Albers', 'Apers', 'Van Bakenes', 'Barbiers', 'Bavinck', 'Behaeghel', 'Beijen', 'Van den Berg', 'Berkhof', 'Bervoets', 'Beyen', 'Beyers',
		'Boere', 'Van Bommel', 'Van den Bosch', 'Brandes', 'Clemens', 'Cleymans', 'Cornelis', 'Cramer', 'Curfs', 'D\'hoedt', 'D\'Hondt', 'Daelemans',
		'De Boer', 'De Doncker', 'De Saeger', 'De Smedt', 'Decaluwe', 'Deddens', 'Derksen', 'Dewitte', 'Van Dievoet', 'Van Dijck', 'Van Dijk',
		'Van Ginkel', 'Dijkstra', 'Dockx', 'Van Dongen', 'Elslander', 'Gernaey', 'Gommaar', 'De Graaf', 'De Graaff', 'Groenewegen', 'De Groot',
		'Haasnoot', 'Harthoorn', 'Van Heemskerck', 'Heemskerk', 'Van Heemskerk', 'Hennie', 'Henny', 'Hens', 'Hensbergen', 'Herkenhoff', 'Heylen',
		'Van der Hoeven', 'Jansen', 'Janssen', 'Janssens', 'De Jong', 'De Jonge', 'De Jongh', 'Jonker', 'Klerks', 'Koopman', 'Van Kooten', 'Koppel',
		'Kroes', 'Kuiper', 'Kuipers', 'Kuyper', 'Van der Laan', 'Lafeber', 'Land', 'Van der Leeuw', 'Van Leeuwen', 'Lemmens', 'Leuris', 'Van Lieshout',
		'Lindeman', 'Littel', 'Maes', 'Manders', 'Marum', 'Van Marum', 'Mathijssen', 'Van Meeuwen', 'Mengelberg', 'Minderhoud', 'Van der Most',
		'Nijhuis', 'Nyssen', 'Nyssens', 'Oostenveld', 'Ottevaere', 'Pels Rijcken', 'Persijn', 'Pijlijser', 'Proot', 'Prummel', 'Pylyser', 'Ratgers',
		'Rens', 'Rongen', 'De Rooij', 'Rotteveel', 'De Ruiter', 'Savery', 'Schoemaker', 'Schrijvers', 'Semmelink', 'Smit', 'Smulders', 'Van der Spek',
		'Spijkerman', 'Standaert', 'Steijn', 'Steyn', 'Stoffels', 'Struik', 'Tessel', 'Thienpont', 'Tillaart', 'Van Tongeren', 'Tukker',
		'Van Cauwenberghe', 'Van den Bergh', 'Van der Linde', 'Van Leemput', 'Vandewalle', 'Veerman', 'Verdoodt', 'Verheyen', 'Verlinden', 'Vindevogel',
		'Vindevoghel', 'Visser', 'Vissers', 'Vleminckx', 'De Vries', 'Wagenaar', 'Wagenmaker', 'Walravens', 'Waterloos', 'Waverijn', 'Wijdeveld',
		'Wildeman', 'De Wit'
	]
};

module.exports = provider;
